import React, { useEffect } from 'react';
import Switch from 'react-router-dom/Switch';
import { Route, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  HomePage,
  CategoriesPage,
  FeaturedPage,
  MostPopularPage,
  RecentlyAddedPage,
  SearchPage,
  MyAppsPage,
  DetailsPage
} from './pages';

const AppsDirectoryRouter = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <Switch>
      <Route path="/apps/:appId/details" component={DetailsPage} />
      <Route path="/apps/my-apps" component={MyAppsPage} />
      <Route path="/apps/recently-added" component={RecentlyAddedPage} />
      <Route path="/apps/most-popular" component={MostPopularPage} />
      <Route path="/apps/featured-apps" component={FeaturedPage} />
      <Route path="/apps/search" component={SearchPage} />
      <Route path="/apps/categories/:categoryKey" component={CategoriesPage} />
      <Route path="/apps/" component={HomePage} exact />
      <Route path="/apps" component={HomePage} exact />
    </Switch>
  );
};

AppsDirectoryRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired
  }).isRequired
};

export default withRouter(AppsDirectoryRouter);
